import React, { useContext, useEffect, useState } from 'react'
import io, { Socket } from 'socket.io-client'

const SocketContext = React.createContext({} as ISocketContext)

export function useSocket() {
    return useContext(SocketContext)
}

interface ISocketProviderProps {
    roomId: string,
    playerId: string,
    children: JSX.Element | JSX.Element[]
}

interface ISocketContext {
    socket: Socket | undefined
    setSocket: (socket: Socket) => void
    playerId: string
}

export default function SocketProvider({ roomId, playerId, children }: ISocketProviderProps) {
    const [socket, setSocket] = useState<Socket>()
    useEffect(() => {
        const options = {
            query: { roomId, playerId },
            pingInterval: 25000,
            pingTimeout: 120000,
        }
        const newSocket = process.env.NODE_ENV === "development"
            ? io("http://localhost:8080", options)
            : io(options)
        setSocket(newSocket)
        return () => {
            newSocket.close()
        }
    }, [roomId, playerId])

    const value: ISocketContext = {
        socket: socket,
        setSocket: setSocket,
        playerId: playerId
    }

    return (
        <SocketContext.Provider value={value}>
            {children}
        </SocketContext.Provider>
    )
}
